import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./styles/Sidebar.css";
import { useAuth } from "../context/AuthContext";
import {
  FiHome,
  FiMail,
  FiPieChart,
  FiCheckSquare,
  FiUser,
  FiSettings,
  FiHelpCircle,
  FiLogOut,
  FiChevronLeft,
  FiChevronRight,
  FiSend
} from "react-icons/fi";
import { CrownOutlined } from '@ant-design/icons';

const Sidebar = () => {
  const [isMinimized, setIsMinimized] = useState(window.innerWidth <= 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
  const navigate = useNavigate();
  const { logOut } = useAuth();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsMinimized(mobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsMinimized(!isMinimized);
  };

  const handleLogout = async () => {
    try {
      await logOut();
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  // ✅ MEO-style menu items (Tasks removed, paths aligned with MEO)
  const menuItems = [
    { path: "/", name: "Automate Emails", icon: <FiSend /> },
    { path: "/dashboard", name: "Dashboard", icon: <FiHome /> },
    { path: "/campaigns", name: "Email Campaigns", icon: <FiMail /> },
    { path: "/subscribe", name: "Subscription", icon: <CrownOutlined /> },
    { path: "/analytics", name: "Analytics", icon: <FiPieChart /> },
    { path: "/manage-accounts", name: "Manage Gmail", icon: <FiMail /> },
    { path: "/profile", name: "Profile", icon: <FiUser /> },
    { path: "/settings", name: "Settings", icon: <FiSettings /> },
    { path: "/help", name: "Help", icon: <FiHelpCircle /> },
  ];

  return (
    <div className={`sidebar ${isMinimized ? "minimized" : "expanded"} ${isMobile ? "mobile" : ""}`}>
      {!isMobile && (
        <div className="sidebar-header">
          {!isMinimized && <h2>Fan Creator</h2>}
          <button className="toggle-btn" onClick={toggleSidebar}>
            {isMinimized ? <FiChevronRight /> : <FiChevronLeft />}
          </button>
        </div>
      )}

      <div className="sidebar-menu">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`sidebar-item ${location.pathname === item.path ? "active" : ""}`}
            data-tooltip={isMinimized ? item.name : null}
          >
            <span className="sidebar-icon">{item.icon}</span>
            {!isMinimized && <span className="sidebar-text">{item.name}</span>}
          </Link>
        ))}

        <button 
          className="sidebar-item logout-btn" 
          onClick={handleLogout}
          data-tooltip={isMinimized ? "Logout" : null}
        >
          <span className="sidebar-icon"><FiLogOut /></span>
          {!isMinimized && <span className="sidebar-text">Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
